import type { ProgramWindow } from "@/interfaces/program";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// "Sep 20 - 26, 2026" from a program window, without pulling in a date library
// or re-parsing anything into the viewer's timezone. These are calendar dates,
// not instants - a Date would shift them across a date line.
export function formatWindow({ starts_on, ends_on }: ProgramWindow) {
  if (!starts_on || !ends_on) return "";

  const fmt = (iso: string, withYear = false) => {
    const [y, m, d] = iso.split("-").map(Number);
    const month = MONTHS[m - 1];
    return withYear ? `${month} ${d}, ${y}` : `${month} ${d}`;
  };

  return `${fmt(starts_on)} - ${fmt(ends_on, true)}`;
}
